<template>
    <!-- Einzelversicherung (ARNS - tarif7) -->
    <div class="versicherungs-button" role="button" tabindex="0" @click="$emit('select')" @keydown.enter="$emit('select')" @keydown.space.prevent="$emit('select')">
        <input type="checkbox" id="einzelversicherung" class="d-none" :checked="selected">
        <label 
            class="d-flex flex-column p-3 border rounded w-100" 
            data-type="einzelversicherung"
            :class="{ 'selected': selected }"
        >
            <div class="d-flex justify-content-between align-items-center">
                <einzelversicherung_icon></einzelversicherung_icon>
                <h1>{{ beitragStr }}</h1>
            </div>
            <h3 class="mt-2">Einzelversicherung</h3>
        </label>
    </div>
</template>

<script setup>
import einzelversicherung_icon from "@/components/icons/einzelversicherung_icon.vue";

defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    beitragStr: {
        type: String,
        default: 'ab 21,60 €'
    }
});

defineEmits(['select']);
</script>

<style scoped>
/* Selected State Styling */
label.selected {
    background-color: var(--vigo-1-500-bg) !important;
}

label.selected h1,
label.selected h3 {
    color: var(--vigo-hell-text) !important;
}

label.selected :deep(svg path) {
    fill: var(--vigo-hell-bg) !important;
}
</style>
